<template>
    <div class="child2">
        <el-form
                :inline="true"
                :model="searchForm"
                ref="searchForm"
                size="mini"
                style="margin-bottom: -18px;"
        >
            <el-form-item
            >
                <el-input
                        v-model="searchForm.goodsname"
                        placeholder="商品名称/商品编号"
                        width="50"
                />
            </el-form-item>

            <el-form-item>
                <el-button
                        type="primary"
                        @click="handleSearchFormSubmit"
                >
                    <d2-icon name="search" /> 查询
                </el-button>
            </el-form-item>

            <el-form-item>
                <el-button @click="handleSearchFormReset">
                    <d2-icon name="refresh" /> 重置
                </el-button>
            </el-form-item>
            <el-form-item>
                <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-circle-plus"
                        @click="add"
                >
                    新增
                </el-button>

                <el-button
                        v-if="multipleSelection.length>0"
                        type="primary"
                        size="mini"
                        icon="el-icon-top"
                        @click="batchUpper"
                >
                    批量上架
                </el-button>
                <el-button
                        v-if="multipleSelection.length>0"
                        type="primary"
                        size="mini"
                        icon="el-icon-bottom"
                        @click="batchLower"
                >
                    批量下架
                </el-button>
                <el-button
                        v-if="multipleSelection.length>0"
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                        @click="batchDel"
                >
                    删除
                </el-button>
            </el-form-item>
        </el-form>

        <el-table
                :data="tableData2"
                v-loading="loading"
                size="small"
                stripe
                highlight-current-row
                style="width: 100%;"
                @selection-change="handleSelectionChange"
                @sort-change="handleSortChange"
        >

            <el-table-column
                    type="selection"
                    width="55"
            >
            </el-table-column>
            <el-table-column
                    label="编号"
            >
                <template slot-scope="scope">
                    {{scope.row.googs_no}}
                </template>
            </el-table-column>

            <el-table-column
                    label="商品图片"
                    :show-overflow-tooltip="true"
                    width="120"
            >
                <template slot-scope="scope">
                    <img :src= "getImgUrl(scope.row)" style="width: 100px;height: 100px; "/>
                </template>
            </el-table-column>
            <el-table-column
                    label="商品名称"
                    :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    {{scope.row.goodsname}}
                </template>
            </el-table-column>
            <el-table-column
                    label="价格"
                    :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    {{scope.row.goodsprice}}
                </template>
            </el-table-column>
            <el-table-column
                    label="原价格"
                    :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    {{scope.row.originalprice}}
                </template>
            </el-table-column>
            <el-table-column
                    label="上下架"
                    :show-overflow-tooltip="true"
            >

                <template slot-scope="scope">
                    <el-switch
                            v-model="scope.row.types"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-value="0"
                            inactive-value="1"
                            @change="changeSwitch(scope.row)">
                    </el-switch>
                </template>

            </el-table-column>
            <el-table-column
                    label="库存"
                    :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    {{scope.row.total_num}}
                </template>
            </el-table-column>


        <el-table-column
                label="计价单位"
                :show-overflow-tooltip="true"
        >
            <template slot-scope="scope">
                {{scope.row.valuation_unit}}
            </template>
        </el-table-column>
            <el-table-column
                    label="销量"
                    :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    {{scope.row.user_num}}
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="250"
            >
                <template slot-scope="scope">
                    <el-button type="primary" plain  size="mini"  @click="openEditForm(scope.row)">修改</el-button>
                    <el-button type="primary" plain  size="mini"  @click="del(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: center;margin-top: 30px;">
            <el-pagination
                    :current-page="page.current"
                    :page-size="page.size"
                    :total="page.total"
                    :page-sizes="[1,10,50,100, 200, 300, 400]"
                    layout="total, sizes, prev, pager, next, jumper"
                    style="margin: -10px;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
            >
            </el-pagination>
        </div>
        <edit-form
                :oneagent="oneagent"
                v-model="editFormVisible"
                @submit="getTableData22"
        />
    </div>
</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import editForm from "./editForm";
    import util from '@/libs/util.js'
    export default {
        name: "child2",
        props: ["agentid_f2"],
        components: { editForm},
        data() {
            return {
                searchForm: {
                    advTitle: ""
                },
                loading: false,
                tableData2: [],
                multipleSelection: [],
                page: {
                    current: 1,
                    size: 10,
                    total: 0
                },
                sort: {
                    prop: "",
                    order: ""
                },
                oneagent: {},
                editFormVisible: false
            };
        },
        watch: {
            agentid_f2(val) {
                console.log("###########");
                this.getTableData2();
            }
        } ,
        mounted() {
            this.getTableData2();
        },
        methods: {
            getTableData22() {
                this.getTableData2();
                this.$emit('refreshNoheader');
            },
            changeSwitch (data) {
                console.log(data.types);
                agentService.updateYearGoodtypes({id:data.id,types:data.types,agentid:util.cookies.get('agentid')}).then(() => {
                    this.getTableData2();
                });
            },
            getImgUrl(row){
                var good_url=row.goodsimg;
                if(good_url.match(",")){
                    var str = good_url.split(',');
                    good_url=str[0];
                }

                return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+good_url;
            },
            getTableData2() {

                let query = {
                    pageIndex: this.page.current,
                    pageSize: this.page.size,
                    sortBy: this.sort.prop,
                    agentid: util.cookies.get('agentid'),
                    descending: this.sort.order === "descending",
                    filter: this.searchForm
                };
                agentService.getYearGoogsPagedList(query).then(data => {
                    this.tableData2 = data.rows;
                    this.page.total = data.totalCount;
                });
                this.$emit('refreshNoheader');
            },
            handleSearchFormSubmit() {
                this.getTableData2();
            },
            handleSearchFormReset() {
                this.$refs.searchForm.resetFields();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleSortChange(val) {
                this.sort.prop = val.prop;
                this.sort.order = val.order;
                this.getTableData2();
            },
            handleSizeChange(val) {
                this.page.size = val;
                this.getTableData2();
            },
            handleCurrentChange(val) {
                this.page.current = val;
                this.getTableData2();
            },
            openEditForm(oneagent) {
                this.oneagent = oneagent;
                this.editFormVisible = true;
            },
            add() {
                this.oneagent = {};
                this.editFormVisible = true;
            },
            batchDel() {
                this.$confirm("确认删除？", "确认信息", {
                    distinguishCancelAndClose: true,
                    confirmButtonText: "删除",
                    cancelButtonText: "取消"
                }).then(() => {
                    agentService
                        .delYearGoodss({
                            ids: JSON.stringify(this.multipleSelection.map(s => s.id)),
                            googstype_ids: JSON.stringify(this.multipleSelection.map(s => s.googstype_id))
                        })
                        .then(() => {
                            this.getTableData2();
                            this.$emit('refreshNoheader');
                        });
                });
            },
            batchUpper() {
                this.$confirm("确认上架？", "确认信息", {
                    distinguishCancelAndClose: true,
                    confirmButtonText: "上架",
                    cancelButtonText: "取消"
                }).then(() => {
                    agentService
                        .batchUpperYearGoods({
                            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
                        })
                        .then(() => {
                            this.getTableData2();
                        });
                });
            },
            batchLower() {
                this.$confirm("确认下架？", "确认信息", {
                    distinguishCancelAndClose: true,
                    confirmButtonText: "下架",
                    cancelButtonText: "取消"
                }).then(() => {
                    agentService
                        .batchLowerYearGoods({
                            ids: JSON.stringify(this.multipleSelection.map(s => s.id))

                        })
                        .then(() => {
                            this.getTableData2();
                        });
                });
            },
            del(oneagent) {
                this.$confirm("确认删除？", "确认信息", {
                    distinguishCancelAndClose: true,
                    confirmButtonText: "删除",
                    cancelButtonText: "取消"
                }).then(() => {
                    agentService.delYearGoods({id:oneagent.id,googstype_id:oneagent.googstype_id}).then(() => {
                        this.getTableData2();
                        this.$emit('refreshNoheader');
                    });
                });
            }
        }
    };
</script>
